import React from 'react';
import { motion } from 'framer-motion';
import { Target, TrendingUp } from 'lucide-react';

export function ClientGoalCompletion() {
  const goals = [
    { name: 'Weight Loss', progress: 85, target: '10kg', current: '8.5kg' },
    { name: 'Strength Gain', progress: 72, target: '100kg', current: '72kg' },
    { name: 'Endurance', progress: 90, target: '10km', current: '9km' }
  ];

  return (
    <div className="theme-card p-6">
      <div className="flex items-center gap-3 mb-6">
        <Target className="w-5 h-5 text-primary" />
        <h2 className="text-lg font-semibold">Goal Completion</h2>
      </div>

      <div className="space-y-6">
        {goals.map((goal, index) => (
          <motion.div
            key={goal.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="space-y-2"
          >
            <div className="flex items-center justify-between">
              <div className="space-y-1">
                <div className="font-medium">{goal.name}</div>
                <div className="text-xs text-muted-foreground">
                  {goal.current} / {goal.target}
                </div>
              </div>
              <div className="flex items-center gap-2">
                <TrendingUp className="w-4 h-4 text-success" />
                <span className="text-success">{goal.progress}%</span>
              </div>
            </div>
            <div className="h-2 bg-muted rounded-full overflow-hidden">
              <div 
                className="h-full bg-primary transition-all"
                style={{ width: `${goal.progress}%` }}
              />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}